import React, { useState, useEffect } from 'react';
import './home.css';
import { useTranslation } from 'react-i18next';
const { Buffer } = require('buffer');

const config = require('../config');
const host = config.host;
const port = config.port;

const colour_map = {"#FFD700": "gold", "#E0BFB8": "rose gold", "#e5e4e2": "platinum"};

export function Home() {
    const test_url = "";
    const [imageURL, setImageURL] = useState(""); 
    const [quota, setQuota] = useState(null); // change later
    const [keyword, setKeyword] = useState("");
    const [selectedColor, setSelectedColor] = useState(null); // color is material in this code
    const [selectedShape, setSelectedShape] = useState(null);
    // const handleColorClick = (color) => {
    //   setSelectedColor(color);
    // }
    const [selectedColors, setSelectedColors] = useState([]);
    const { t } = useTranslation();


    // fetch the quota for the user when first render of the page
    // uncomment it later
    useEffect(() => {
      const token = sessionStorage.getItem("token");
      fetch(`/users/quota`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        }
      })
      .then(response => response.json())
      .then(data => {
        setQuota(data.quota);
      });
    }, []);

    // const handleAddFavourite = () => {
    //   const token = sessionStorage.getItem("token");
    //   // const base64Data = imageURL.replace(/^data:image\/\w+;base64,/, ''); 
    //   // console.log(base64Data);
    //   // const image_binaryData = Buffer.from(base64Data, 'base64');
    //   // console.log(image_binaryData);

    //   fetch(`http://${host}:${port}/users/update_favourite_image`, { 
    //     method: 'POST',
    //     headers: {
    //       'Content-Type': 'application/json',
    //       'Authorization': `Bearer ${token}`
    //     },
    //     body: JSON.stringify({
    //       image: imageURL
    //       })
    //   })
    //   .then(response => response.json())
    //   .then(data => console.log(data)) 
    //   .catch(error => console.error('Error when updating quota:', error));
    // }

    const handleDownloadAndContactDiaholic = () => {
      // Create a link element
      const download_link = document.createElement('a');
      download_link.download = 'downloaded_image.jpeg';
      download_link.href = imageURL;
      document.body.appendChild(download_link);
      // Programmatically click the link to trigger the download
      download_link.click();
      document.body.removeChild(download_link);

      // create another link to contact diaholic via whatsapp
      const diaholic_whatsapp_link = document.createElement('a');
      diaholic_whatsapp_link.href = "https://wa.me/85261058554";
      diaholic_whatsapp_link.target = "_blank"
      document.body.appendChild(diaholic_whatsapp_link);
      // Programmatically click the link to trigger the download
      diaholic_whatsapp_link.click();
      document.body.removeChild(diaholic_whatsapp_link);

    }

    const handleFindDiaholic = (e) => {
      //e.preventDefault();
      // create another link to contact diaholic via whatsapp
      const diaholic_link = document.createElement('a');
      diaholic_link.href = "https://www.instagram.com/diaholic_ring";
      diaholic_link.target = "_blank";
      //diaholic_link.rel="noopener noreferrer";
      document.body.appendChild(diaholic_link);
      diaholic_link.click();
      document.body.removeChild(diaholic_link);
    }

    
    const reduce_quota_by_one = async (quota) => {
      const token = sessionStorage.getItem("token");
  
      fetch(`/users/update_quota`, { 
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          quota: quota, // the current quota
          })
      })
      .then(response => response.json())
      .then(data => setQuota(data.quota)) 
      .catch(error => console.error('Error when update_quota:', error));
    }

    const handleColorClick = (colorName) => {
      setSelectedColors(prev => {
        // Remove if already selected
        if (prev.includes(colorName)) {
          return prev.filter(c => c !== colorName);
        }
        // Add new color if we have less than 2 selected
        return prev.length < 2 ? [...prev, colorName] : prev;
      });
    };

    const handleGeneration = async (e) => {
      e.preventDefault();
      const token = sessionStorage.getItem("token");
      if(selectedColors.length === 0 || !selectedShape || !keyword){
        alert("You have to choose a colour and a shape and keyword");
        return;
      }

    
      function iscontainCommaAndSpaceButNoOtherCharaters(input){
        const regex = /^[ ,]+$/;
        return regex.test(input)
      }
      if(iscontainCommaAndSpaceButNoOtherCharaters(keyword)){
        alert("Your keyword should contain other charater other than space and comma");
        return;
      }

      if(quota <= 0){
        alert("You do not have enough quota to generate the image");
        return;
      }
      
      function truncateKeyword_if_longer_than_60(input) {
        if (input.length > 60) {
            return input.substring(0, 60);
        }
        return input;
      }

      function combine_colours_into_a_string(selectedColors){
        if (selectedColors.length <= 1){
          return selectedColors[0]
        }
        else{
          return `${selectedColors[0]} and ${selectedColors[1]}` 
        }
      }

      // loading for waiting the image to be generated, later change it to a video displaying diaholic web
      setImageURL("./images/loading-icon.gif");
      try{
        const gen_image_response = await fetch(`/stable_diffusion/generate_image`, { 
          method: 'POST',
          body: JSON.stringify({
            material: combine_colours_into_a_string(selectedColors),
            shape: selectedShape,
            keyword: truncateKeyword_if_longer_than_60(keyword), 
            setting_type: "halo"
          }),
          headers:{
            'Content-Type': 'application/json',
            "Authorization": `Bearer ${token}`
          }
        });
  
        if(!gen_image_response.ok){
          // stop this function
          setImageURL("");
          throw new Error("the image cannot be generated successfully");
        }
        else{
          //setImageURL("./images/loading-icon.gif");
          await reduce_quota_by_one(quota);
          const gen_image_response_data = await gen_image_response.json();
          setImageURL("data:image/jpeg;base64, ".concat(gen_image_response_data.image));
          
        }
      }
      catch (error){
        console.error("Error when generating image:", error);
      }
      

      // fetch(`http://${host}:${port}/stable_diffusion/generate_image`, { 
      //   method: 'POST',
      //   body: JSON.stringify({
      //     prompt: "a pair of wedding rings, with bezel setting, cruve, no hands" //modify
      //   }),
      //   headers:{
      //     'Content-Type': 'application/json',
      //     "Authorization": `Bearer ${token}`
      //   }
      // })// need to change when deploy to the cloud
      // // the response is the generated image in base64 format
      // .then(response => {
       
      //   if(!response.ok){
      //     console.log("hello");
      //     // stop this function
      //     throw new Error("the image cannot be generated successfully");
      //   }
      //   else{
          
      //     reduce_quota_by_one();
      //     return response.json();
      //   }
      // })
      // // be careful the format of the image(jpeg, png)
      // .then(data => {setImageURL("data:image/jpeg;base64, ".concat(data.image));}
      // )
      // .catch(error => {
      //   console.error("Error when generating image:", error);
      //   });
      
    };

    const shape_list_all = ["straight", "V-shape", "X-shape","triangle", 
      "olive", "crossed", "geometry", "step", "twist", 
      "curve", "special", "upper", "thick", "wave"];
    const shape_list_limited = ["straight", "crossed", "V-shape", "X-shape", "curve", "wave"];
  
    return (
      <div className="home-content-container">
        <div className="form-container">
          <form id="ringForm">
            <h6>{t("you_remain")} {quota} {t("quota_to_generate_images")}</h6>
            <label htmlFor="color">{t("choose_colours")}</label>
            <div className="color-selection-container">
              <div className="color-options">
                {["#FFD700", "#E0BFB8", "#e5e4e2"].map(color => (
                  <div className="color-option" key={color}>
                    <div
                      onClick={() => handleColorClick(colour_map[color])}
                      className="color-box"
                      style={{
                        backgroundColor: color,
                        border: selectedColors.includes(colour_map[color]) 
                          ? '4px solid black' 
                          : '1px solid #ccc'
                      }}
                    />
                    <span className="color-description">
                      {t(colour_map[color])}
                    </span>
                  </div>
                ))}
              </div>
          </div>


            <label htmlFor="shape">{t("choose_a_shape")}</label>
            <div className="shape-selection-container">
              <div className="shape-options">
                {shape_list_limited.map(shape => (
                  <div
                    key={t(shape)}
                    onClick={() => setSelectedShape(shape)}
                    className="shape-box"
                    style={{
                      backgroundColor: "#FFFFFF",
                      border: selectedShape === shape ? '3px solid black' : '1px solid #ccc'
                    }}
                  > 
                  {t(shape)}
                  </div>
                ))}
              </div>
            </div>
            <label htmlFor="text">{t("describe_your_desired_rings")}</label>
            <input
              type="text"
              placeholder={t("keyword")}
              value={keyword}
              onChange={(e) => {setKeyword(e.target.value);}}
            />
            <button onClick={(e) => { handleGeneration(e); setKeyword(""); }}>{t("generate")}</button>
            {/* <a href="https://www.instagram.com/diaholic_ring" target="_blank" rel="noopener noreferrer" className="link"> {t("find_diaholic_instagram")}</a> */}
          </form>
        </div>
        <div className="image-container">
        {imageURL.length > 0 && <p>We disclaim all responsibility or liability for the following image.</p>}
          {imageURL.length > 0 && <img src={imageURL} alt="Ring" className="side-image" />}
          <div className="button-container">
            {/* {imageURL.length > 0 && <button onClick={handleAddFavourite} className="equal-button">{t("add_favourite")}</button>} */}
            {imageURL.length > 0 && <button onClick={handleDownloadAndContactDiaholic} className="equal-button">{t("download_the_image_and_contact_diaholic")}</button>}
          </div>
          <div className="button-container">
            {/* {imageURL.length > 0 &&
            <a href="https://www.example.com" target="_blank" rel="noopener noreferrer" className="link"> {t("book_your_customized_ring")} </a>} */}

            {/* {imageURL.length > 0 && <a href="https://wa.me/85261058554" target="_blank" className="link">{t("contact")} DIAHOLIC</a>} */}
            </div>
        </div>
      </div>
    );
  }
  
